import { PaymentMethodEnum } from "@edp-enums/payment-method.enum";
import { MonthlyInvoice } from "@edp-models/billing.model";

export interface IbillingState {
    monthlyInvoices: MonthlyInvoice[];
    paymentTab: PaymentMethodEnum;
    tariffFiles: [];
}

export const initialBillingState: IbillingState = {
    monthlyInvoices: null,
    tariffFiles: null,
    paymentTab: null
};
